import React, { Component } from 'react';
import { Modal, Button, Form, Checkbox } from 'semantic-ui-react';
// import MutationInfo from '../MutationInfo';
import SaveButtonWithTooltip from '../SaveButtonWithTooltip';
import Steps from './Steps.js';
import Tab from './Tab.js';
import {
  lengthGt,
  notEmpty,
  truthy,
  report,
  validUser
} from '../../../../common/utils/inputValidator.js';
import { updateInPath, logError } from '../../../../common/utils';
import {
  clone,
  any,
  map,
  pipe,
  filter,
  complement,
  isEmpty } from 'ramda';
import { withNamespaces } from 'react-i18next';
import { Auth } from 'aws-amplify';


const BLANK = {
  name: '',
  robotName: '',
  robotNumber: 0,
  hasAcceptedCompetitionRules: false,
  event: {
    id: '',
    title: ''
  },
  competition: {
    id: '',
    title: '',
    members: 0
  },
  mentor: {},
  members: []
};

class MutationModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      save: {
        enabled: true,
        errors: []
      },
      data: clone(props.data) || BLANK,
      activeTabIndex: 0
    };

    if (!props.data) {
      this.updateMentorInfo();
    }
  }

  updateMentorInfo = async () => {
    try {
      const user = await Auth.currentAuthenticatedUser();
      this.setState(s => updateInPath(s, 'data.mentor', user.attributes));
    } catch (err) {
      logError(err);
    }
  };

  saveEnabled = (data) => {
    const checks = [
      lengthGt(data.name, 4, 'Name'),
      notEmpty(data.competition.id, 'Competition'),
      truthy(data.hasAcceptedCompetitionRules, true, 'Must accept competition rules')
    ];

    return report(checks);
  };

  handleSave = () => {
    this.props.onSave(this.state.data);
  };

  handleDelete = async () => {
    const data = clone(this.state.data);
    this.props.onDelete(data.teamId, data.userId);
  };

  handleChange = (e, {name, value}) => {
    this.setState(prevState => updateInPath(prevState, 'data.' + name, value));
  };

  handleToggle = (e, {name, checked}) => {
    this.setState(prevState => updateInPath(prevState, 'data.' + name, checked));
  };

  handleCompetitionUpdate = (e, { competition }) => {
    this.setState(prevState => updateInPath(prevState, 'data.competition', competition));
  };

  handleEventUpdate = (e, {name, value, options }) => {
    this.setState(prevState => {
      const newState = clone(prevState);
      newState.data.event.id = value;
      newState.data.event.title = name;
      newState.data.competition.id = '';
      newState.data.competition.members = 0;
      return newState;
    });
  };

  handleUpdateMentor = (e, { name, value }) => {
    // updateInpath does not work with 'custom:blaaah' paths
    this.setState(prevState => {
      const newState = clone(prevState);
      newState.data.mentor[name] = value;

      if (name === 'custom:country_of_residence' && value !== 'ee') {
        newState.data.mentor['custom:county_of_residence'] = '';
      }
      return newState;
    });
  };

  // TODO merge with updateMentor
  handleUpdateMembers = (e, { name, value, rowix }) => {
    //updateInpath does not work with 'custom:blaaah' paths
    this.setState(prevState => {
      const newState = clone(prevState);

      if (!newState.data.members[rowix]) {
        newState.data.members[rowix] = {};
      }
      newState.data.members[rowix][name] = value;

      if (name === 'custom:country_of_residence' && value !== 'ee') {
        newState.data.members[rowix]['custom:county_of_residence'] = '';
      }
      return newState;
    });
  };

  handleTabChange = (e, {activeIndex}) => {
    this.setState(prevState => updateInPath(prevState, 'activeTabIndex', activeIndex));
  }

  hasValidCompetitionData = (competition) => {
    const c = clone(competition) || {};
    return !!c.id;
  };

  hasValidMentorData = (mentor) => {
    return validUser(mentor);
  };

  hasValidTeamData = (data, competition) => {
    const d = clone(data) || {},
          m = d.members || [];

    if (!d.name || !m.length) {
      return false;
    } else if (competition.robotRequired && !d.robotName) {
      return false;
    }

    const isNotEmpty = complement(isEmpty);

    // make sure that all team members have valid information
    const x = pipe(
      map((member) => filter((f) => isNotEmpty(f), member)),
      filter(isNotEmpty),
      any((f) => Object.keys(f).length < 7)
    )(m);
    
    return !x;
  };

  hasValidMemberData = () => {
    return true;
  }

  hasAcceptedRules = (acceptedRules) => {
    return !!acceptedRules;
  }
  
  render() {
    // TODO this ...Ok part is not elegant
    const { t, open, events } = this.props,
          data = this.state.data,
          competition = data.competition,
          mentorOk = this.hasValidMentorData(data.mentor),
          teamOk = this.hasValidTeamData(data, competition),
          rulesOk = this.hasAcceptedRules(data.hasAcceptedCompetitionRules),
          competitionOk = this.hasValidCompetitionData(competition);

    return (
      <Modal open={open}>
        <Modal.Header content={t('private:addTeam.' + (data.id ? 'add' : 'edit'))} />
        <Modal.Content>
          <Steps
            competitionOk={competitionOk}
            mentorOk={mentorOk}
            teamOk={teamOk}
            rulesOk={rulesOk}
            activeStep={this.state.activeTabIndex}
          />
          <Form>
            {/* TODO all these event should be moved inside */}
            <Tab
              data={data}
              events={events}
              onEventUpdate={this.handleEventUpdate}
              onCompetitionUpdate={this.handleCompetitionUpdate}
              onMentorUpdate={this.handleUpdateMentor}
              onMembersUpdate={this.handleUpdateMembers}
              onChange={this.handleChange}
              onDelete={this.handleDelete}
              onTabChange={this.handleTabChange}
            />
          </Form>
        </Modal.Content>
        <Modal.Actions>
          { competition &&
            competition.id && <Checkbox
                                required
                                label={t('private:addTeam.competitions.acceptRules')}
                                name='hasAcceptedCompetitionRules'
                                checked={!!data.hasAcceptedCompetitionRules}
                                onChange={this.handleToggle} />}
          {/* <MutationInfo */}
          {/*   who={modal.data.createdBy} */}
          {/*   when={modal.data.createdAt}/> */}
          <Button
            content={t('common:cancel')}
            onClick={this.props.onClose}
          />
          <SaveButtonWithTooltip
            enabled={competitionOk && teamOk && mentorOk && rulesOk}
            tooltip={this.state.save.errors}
            onSave={this.handleSave}/>
        </Modal.Actions>
      </Modal>
    );
  };
};

export default withNamespaces(['private', 'common'])(MutationModal);



// WEBPACK FOOTER //
// ./src/private/common/components/Team/index.js